import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ItemLightDto } from "../../../core/items/ItemDataTypes";
import { isNil } from "lodash";


export interface TournoiFrancoState {
    items: Array<ItemLightDto>,


    noCamc: boolean,
    noZl: boolean,
    keysy: boolean,
    openDeku: boolean,
    openFountain: boolean,
    shuffleGerudoCard: boolean,
    ocarinaShuffle: boolean,
    oneMajorItem: boolean,
    bossShuffle: boolean,
    erDungeon: boolean,
    bombchuBag: boolean,
    cowSanity: boolean,
    shopSanity: boolean,
    scrubSanity: boolean,
    trials: boolean,
    songsanity: boolean,
    tokenDungeons:boolean,
    tokenOverworld:boolean
    tokenAll:boolean,
    bkSanity: boolean,
    randomOwlWarp: boolean,
    closedDot: boolean,
    bossSoulSanity: boolean,
    mixPool: boolean,
    mixPoolDungeon: boolean,
    songDungeonReward: boolean,
    keysanityAll: boolean,
    keyring: boolean,
    itemPoolMinimal: boolean,
    itemPoolScarce: boolean,
    allSoulSanity: boolean,
    regionalSoulSanity: boolean,
    beatableOnly: boolean,
    shortcut: boolean,
}

export const initialTournoiFrancoState: TournoiFrancoState = {
    items: [],
    noCamc: false,
    noZl: false,
    keysy: false,
    openDeku: false,
    openFountain: false,
    shuffleGerudoCard: false,
    ocarinaShuffle: false,
    oneMajorItem: false,
    bossShuffle: false,
    erDungeon: false,
    bombchuBag: false,
    cowSanity: false,
    shopSanity: false,
    scrubSanity: false,
    trials: false,
    songsanity: false,
    tokenDungeons:false,
    tokenOverworld:false,
    tokenAll:false,
    bkSanity: false,
    randomOwlWarp: false,
    closedDot: false,
    bossSoulSanity: false,
    mixPool: false,
    mixPoolDungeon: false,
    songDungeonReward: false,
    keysanityAll: false,
    keyring: false,
    itemPoolMinimal: false,
    itemPoolScarce: false,
    allSoulSanity: false,
    regionalSoulSanity: false,
    beatableOnly: false,
    shortcut: false,
}

export const tournoiFrancoSlice = createSlice({
    name: 'ootr tracker franco reducer',
    initialState: initialTournoiFrancoState,
    reducers: {
        resetState(state: TournoiFrancoState){
            state.items = [];
        },
        setItems(state: TournoiFrancoState, action: PayloadAction<ItemLightDto>) {
            if (!isNil(state.items?.find(i => i.id === action.payload.id))) {
                state.items = [...state.items.filter(i => i.id !== action.payload.id), action.payload]
            }
            else if(isNil(state.items))
                state.items = [action.payload]
            else
                state.items = [...state.items, action.payload]
        },
        setNoCamc(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.noCamc = action.payload
        },
        setNoZl(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.noZl = action.payload
        },
        setKeysy(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.keysy = action.payload
        },
        setOpenDeku(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.openDeku = action.payload
        },
        setOpenFountain(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.openFountain = action.payload
        },
        setShuffleGerudoCard(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.shuffleGerudoCard = action.payload
        },
        setOcarinaShuffle(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.ocarinaShuffle = action.payload
        },
        setOneMajorItem(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.oneMajorItem = action.payload
        },
        setBossesShuffle(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.bossShuffle = action.payload
        },
        setErDungeon(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.erDungeon = action.payload
        },
        setBombchuBag(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.bombchuBag = action.payload
        },
        setCowsanity(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.cowSanity = action.payload
        },
        setShopsanity(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.shopSanity = action.payload
        },
        setScrubsanity(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.scrubSanity = action.payload
        },
        setTrials(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.trials = action.payload
        },
        setSongsanity(state: TournoiFrancoState, action: PayloadAction<boolean>) {
            state.songsanity = action.payload
        },
        setTokenDungeon(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.tokenDungeons = action.payload
        },
        setTokenOverworld(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.tokenOverworld = action.payload
        },
        setTokenAll(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.tokenAll = action.payload
        },
        setBkSanity(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.bkSanity = action.payload
        },
        setRandomOwlWarp(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.randomOwlWarp = action.payload
        },
        setClosedDot(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.closedDot = action.payload
        },
        setBossSoulSanity(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.bossSoulSanity = action.payload
        },
        setMixPool(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.mixPool = action.payload
        },
        setMixPoolDungeon(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.mixPoolDungeon = action.payload
        },
        setSongDungeonReward(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.songDungeonReward = action.payload
        },
        setKeysanityAll(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.keysanityAll = action.payload
        },
        setKeyring(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.keyring = action.payload
        },
        setItemPoolMinimal(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.itemPoolMinimal = action.payload
        },
        setItemPoolScarce(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.itemPoolScarce = action.payload
        },
        setAllSoulSanity(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.allSoulSanity = action.payload
        },
        setRegionalSoulSanity(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.regionalSoulSanity = action.payload
        },
        setBeatableOnly(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.beatableOnly = action.payload
        },
        setShortcut(state: TournoiFrancoState, action: PayloadAction<boolean>){
            state.shortcut = action.payload
        },


    }
});

export const {
    setItems,
    setNoCamc,
    setNoZl,
    setKeysy,
    setOpenDeku,
    setOpenFountain,
    setShuffleGerudoCard,
    setOcarinaShuffle,
    setOneMajorItem,
    setBossesShuffle,
    setErDungeon,
    setBombchuBag,
    setCowsanity,
    setScrubsanity,
    setShopsanity,
    setTrials,
    setSongsanity,
    setTokenDungeon,
    setTokenOverworld,
    setTokenAll,
    setBkSanity,
    setRandomOwlWarp,
    setClosedDot,
    setBossSoulSanity,
    setMixPool,
    setMixPoolDungeon,
    setSongDungeonReward,
    setKeysanityAll,
    setKeyring,
    setItemPoolMinimal,
    setItemPoolScarce,
    setAllSoulSanity,
    setRegionalSoulSanity,
    setBeatableOnly,
    setShortcut,
    resetState

} = tournoiFrancoSlice.actions

export const tournoiFrancoReducer = tournoiFrancoSlice.reducer


